import React, { useState } from "react";
import Navigation from "../Navigation/Navigation";
import { MdKeyboardArrowLeft, MdEast } from "react-icons/md";
// import BannerDetails from "../../assets/banner-detail.png";
import { Image } from "react-bootstrap";
import { Link, useLocation, useParams } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import Table from "react-bootstrap/Table";
import VoucherID from "../../assets/voucher-coupon.svg";
import cd1 from "../../assets/cd-1.svg";
import cd2 from "../../assets/cd-2.svg";
import cd3 from "../../assets/cd-3.svg";
import od1 from "../../assets/od-1.svg";
import od2 from "../../assets/od-2.svg";
import od3 from "../../assets/od-3.svg";
import od4 from "../../assets/od-4.svg";
import od5 from "../../assets/od-5.svg";
import od6 from "../../assets/od-6.svg";
import od7 from "../../assets/od-7.svg";
import pro from "../../assets/user.png";
import pro1 from "../../assets/pro1.svg";
import pro2 from "../../assets/pro-2.svg";
import pro3 from "../../assets/pro-3.svg";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";

const CustomerDetails = () => {
  const location = useLocation();
  const { VoucherTransactionsData, flag } = location.state;

  return (
    <>
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link
              className="page-text"
              to={
                flag === 0 ? "/transactions/vouchers" : "/transactions/coupons"
              }
            >
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>

          <p className="page-maintitle">Customer Details</p>
          <div className="cus-detail d-flex mt-5">
            <div className="pr-4">
              <Image
                loading="lazy"
                src={
                  VoucherTransactionsData.user_profile_image == ""
                    ? pro
                    : VoucherTransactionsData.user_profile_image
                }
                className="customer_profile"
              ></Image>
            </div>
            <div className="mx-3">
              <p className="gi-lable mb-2">
                <Image
                  loading="lazy"
                  src={pro1}
                  className="bl-img mb-1"
                ></Image>
                <b>Name:</b>{" "}
                <span className="pl-10">
                  {VoucherTransactionsData.first_name
                    ? VoucherTransactionsData.first_name
                    : "" + VoucherTransactionsData.last_name
                    ? VoucherTransactionsData.last_name
                    : ""}
                </span>
              </p>
              <p className="gi-lable mb-2">
                <Image
                  loading="lazy"
                  src={pro2}
                  className="bl-img mb-1"
                ></Image>
                <b>Email:</b>{" "}
                <span className="pl-10">{VoucherTransactionsData.email}</span>
              </p>
              <p className="gi-lable mb-2">
                <Image
                  loading="lazy"
                  src={pro3}
                  className="bl-img mb-1"
                ></Image>
                <b>Phone Number:</b>{" "}
                <span className="pl-10">
                  {" "}
                  {VoucherTransactionsData.contact_number}
                </span>
              </p>
            </div>
          </div>
          <div>
            <Accordion
              defaultActiveKey={["0", "1", "2"]}
              alwaysOpen
              className="bl-accordian mt-3 no-accordian"
            >
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <Image loading="lazy" src={cd1} className="bl-img"></Image>{" "}
                  Order Details
                </Accordion.Header>
                <Accordion.Body>
                  <Table className="accordian-table">
                    <tbody>
                      <tr>
                        <td width="300px" className="gi-lable">
                          <Image
                            loading="lazy"
                            src={od1}
                            className="bl-img mb-1"
                          ></Image>
                          Order Number
                        </td>
                        <td>
                          {VoucherTransactionsData.order_no
                            ? VoucherTransactionsData.order_no
                            : ""}
                        </td>
                      </tr>
                      <tr>
                        <td width="300px" className="gi-lable">
                          <Image
                            loading="lazy"
                            src={od2}
                            className="bl-img mb-1"
                          ></Image>
                          {flag === 0 ? "Voucher Name" : "Coupon Name"}
                        </td>
                        <td>
                          {VoucherTransactionsData.order_name
                            ? VoucherTransactionsData.order_name
                            : ""}
                        </td>
                      </tr>
                      <tr>
                        <td width="300px" className="gi-lable">
                          <Image
                            loading="lazy"
                            src={od3}
                            className="bl-img mb-1"
                          ></Image>
                          Marketplace
                        </td>
                        <td>
                          {VoucherTransactionsData.marketplace
                            ? VoucherTransactionsData.marketplace
                            : ""}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Accordion.Body>
              </Accordion.Item>
              {flag === 0 ? (
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    <Image loading="lazy" src={cd2} className="bl-img"></Image>{" "}
                    Price Details
                  </Accordion.Header>
                  <Accordion.Body>
                    <Table className="accordian-table">
                      <tbody>
                        <tr>
                          <td width="300px" className="gi-lable">
                            <Image
                              loading="lazy"
                              src={od4}
                              className="bl-img mb-1"
                            ></Image>
                            Voucher Price ($)
                          </td>
                          <td>
                            {VoucherTransactionsData.amount
                              ? VoucherTransactionsData.amount
                              : ""}
                          </td>
                        </tr>
                        <tr>
                          <td width="300px" className="gi-lable">
                            <Image
                              loading="lazy"
                              src={od5}
                              className="bl-img mb-1"
                            ></Image>
                            Payment Mode
                          </td>
                          <td>{VoucherTransactionsData.payment_type}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  <Image loading="lazy" src={cd3} className="bl-img"></Image>
                  {flag === 0 ? "Voucher Status" : "Coupon Status"}
                </Accordion.Header>
                <Accordion.Body>
                  <Table className="accordian-table">
                    <tbody>
                      <tr>
                        <td width="300px" className="gi-lable">
                          <Image
                            loading="lazy"
                            src={od6}
                            className="bl-img mb-1"
                          ></Image>
                          {flag === 0 ? "Purchased Date" : "Downloaded Date"}
                        </td>
                        <td>
                          {VoucherTransactionsData.date
                            ? VoucherTransactionsData.date
                            : ""}
                        </td>
                      </tr>
                      <tr>
                        <td width="300px" className="gi-lable">
                          <Image
                            loading="lazy"
                            src={od7}
                            className="bl-img mb-1"
                          ></Image>
                          Status / Date
                        </td>
                        <td>
                          {VoucherTransactionsData.redeemption_date
                            ? "Redeemed " +
                              "/ " +
                              VoucherTransactionsData.redeemption_date
                            : "Not Redeemed"}
                        </td>
                      </tr>
                      <tr>
                        <td width="300px" className="gi-lable">
                          <Image
                            loading="lazy"
                            src={VoucherID}
                            className="bl-img mb-1"
                          ></Image>
                          {flag === 0 ? "Voucher ID" : "Coupon ID"}
                        </td>
                        <td>
                          {VoucherTransactionsData.order_code
                            ? VoucherTransactionsData.order_code
                            : "Not available"}
                        </td>
                      </tr>
                      <tr></tr>
                    </tbody>
                  </Table>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
      <PrivacyTermsConditions />
    </>
  );
};

export default CustomerDetails;
